import { styleOverrides } from "./styleOverrides";

const MuiDialogActions = {
  styleOverrides,
};

export { MuiDialogActions };
